module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("52BHv"))).then(() => parcelRequire('1iHdE'));